import React from 'react'
import FormInput from '../../../../library/form/components/FormInput';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import * as fn from "../../../../helper/uiFunctions";

const WorkFlowEditorRow = (props) => {
    const { formObject, viewData, rowKey } = props;

    if (fn.compareNumber(viewData.dataList.isEditMode, 1)) {
        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "activtyId" }} className='uiVal' />
                </li>
                <li className="uiColumnCenter uiColumn200">
                    <FormInput formObject={formObject} rowKey={rowKey} style={{ width: "98%" }}
                        action={{ InputType: "input", paramName: "activityName", actionparam: { } }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormInput formObject={formObject} rowKey={rowKey} style={{ width: "98%" }}
                        action={{ InputType: "input", paramName: "onApprove", actionparam: { } }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormInput formObject={formObject} rowKey={rowKey} style={{ width: "98%" }}
                        action={{ InputType: "input", paramName: "onReject", actionparam: { } }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        action={{ actionId: "refresh",  actionParam: {isEditPlanCriteria:"1", activtyId:"#activtyId" }, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="View/Edit" />} ></FormButton>
                </li>
                <li className="uiColumnCenter uiColumn100 uiActionBlock">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="confirm"
                        onlyIcon={true}
                        tooltip="Confirm Changes"
                        starIconClassName="uiColorNeutralAction"
                        action={{ actionId: "save",  actionParam: { activtyId:"#activtyId" }, containerKey: "row" }}
                        className="" ></FormButton>

                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="cancel"
                        onlyIcon={true}
                        tooltip="Cancel Changes"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "cancel",  actionParam: { activtyId:"#activtyId" }, containerKey: "row" }}
                        className="" ></FormButton>
                </li>
            </ul>
        )
    }
    else {
        return (
            <ul >
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "activtyId" }} />
                </li>
                <li className="uiColumnCenter uiColumn200">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "activityName" }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "onApprove" }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "onReject" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        action={{ actionId: "refresh",  actionParam: {isEditPlanCriteria:"1", activtyId:"#activtyId" }, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="View/Edit" />} ></FormButton>
                </li>
                <li className="uiColumnCenter uiColumn100 uiActionBlock" >
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="edit"
                        onlyIcon={true}
                        tooltip="Edit"
                        starIconClassName="uiColorNeutralAction"
                        action={{ actionId: "edit",  actionParam: { activtyId:"#activtyId" }, containerKey: "row" }}
                        className="" ></FormButton>

                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="clear"
                        onlyIcon={true}
                        tooltip="Delete"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "del",  actionParam: { activtyId:"#activtyId" }, containerKey: "row" }}
                        className="" ></FormButton>
                </li>
            </ul>
        )
    }
}

export default WorkFlowEditorRow